import Keycloak from 'keycloak-js';

// Defensive configuration build to avoid "Failed to construct 'URL': Invalid URL" on refresh
const {
  REACT_APP_TOKEN_API: RAW_KC_URL,
  REACT_APP_KEYCLOAK_REAMLS: RAW_KC_REALM,
  REACT_APP_CLIENT_ID: RAW_KC_CLIENT_ID
} = process.env;

// Basic validators
const isAbsoluteHttp = (val) => typeof val === 'string' && /^https?:\/\//i.test(val);
const trimTrailingSlash = (val) => (typeof val === 'string' ? val.replace(/\/$/, '') : val);

const configErrors = [];
if (!isAbsoluteHttp(RAW_KC_URL)) {
  configErrors.push('REACT_APP_TOKEN_API must be an absolute http(s) URL.');
}
if (!RAW_KC_REALM) {
  configErrors.push('REACT_APP_KEYCLOAK_REAMLS is missing.');
}
if (!RAW_KC_CLIENT_ID) {
  configErrors.push('REACT_APP_CLIENT_ID is missing.');
}

let keycloakService;

// Public routes (e.g. /reset-password) must never trigger any Keycloak redirect.
// Return an inert stub so even if ReactKeycloakProvider or any hook tries to use it,
// nothing happens — no init, no login redirect, no network requests.
const PUBLIC_PATHS = ['/reset-password'];
const isPublicRoute = PUBLIC_PATHS.some((p) => window.location.pathname.startsWith(p));

// If config invalid, log once with guidance and create a stub so app shell can render without crashing.
if (isPublicRoute || configErrors.length) {
  if (configErrors.length) {
    // eslint-disable-next-line no-console
    console.error('[Keycloak Config] Invalid environment configuration:', configErrors.join(' '));
  }
  // Provide a minimal stub to prevent runtime exceptions; any auth call will redirect user explicitly when fixed.
  const stub = {
    authenticated: false,
    init: () => Promise.resolve(false),
    login: () => {},
    logout: () => {},
    updateToken: () => Promise.resolve(false),
    onTokenExpired: null,
    onAuthRefreshSuccess: null,
    onAuthRefreshError: null,
    onAuthLogout: null,
    tokenParsed: null,
    token: null,
    refreshToken: null,
    idToken: null,
    idTokenParsed: null
  };
  keycloakService = stub;
} else {
  keycloakService = new Keycloak({
    url: trimTrailingSlash(RAW_KC_URL),
    realm: RAW_KC_REALM,
    clientId: RAW_KC_CLIENT_ID,
    storage: {
      token: 'localStorage',
      pkce: 'localStorage'
    }
  });
}

export default keycloakService;

// response_type: code
// client_id: dashboard-client
// state: R0hDVmVCa3ROfmFNa2lIfmZ-YjZfQmI4UkNOWWdyVEFBcU11MTZCdGszeFY0
// redirect_uri: https://dashboardrelease.gprddigital.com/
// scope: openid offline_access
// code_challenge: htvrO5AosVxniFpwC6aecN3O_w60N0_kv_9YTBOVGP0
// code_challenge_method: S256
// nonce: R0hDVmVCa3ROfmFNa2lIfmZ-YjZfQmI4UkNOWWdyVEFBcU11MTZCdGszeFY0
